import { InputSwitch } from "primereact/inputswitch";
import {
  CLICKABLE,
  DISABLED,
  SW_BASE,
  SW_INPUT,
  SW_KNOB,
  SW_KNOB_OFF,
  SW_KNOB_ON,
  SW_OFF,
  SW_ON,
} from "../styles";

type Props = {
  checked: boolean;
  label: string;
  disabled?: boolean;
  /** why it is dead, for the rows whose backend field does not exist yet */
  title?: string;
  onChange?: () => void;
};

/**
 * A PrimeReact InputSwitch in `unstyled` mode, dressed from ../styles.
 *
 * It renders a real <input type="checkbox" role="switch">, so it is reachable by
 * Tab, toggles on Space, and announces its state — SW_INPUT stretches it invisibly
 * over the track so the knob can pick its focus ring up as a `peer`.
 */
export function Switch({ checked, label, disabled = false, title, onChange }: Props) {
  return (
    <InputSwitch
      unstyled
      checked={checked}
      disabled={disabled}
      onChange={() => onChange?.()}
      pt={{
        root: {
          className: `${SW_BASE} ${checked ? SW_ON : SW_OFF} ${disabled ? DISABLED : CLICKABLE}`,
          title,
        },
        input: { className: SW_INPUT, "aria-label": label },
        slider: { className: `${SW_KNOB} ${checked ? SW_KNOB_ON : SW_KNOB_OFF}` },
      }}
    />
  );
}
